// Cookie for CookieBot is set as a weirdly stringified object when consent is given/denied.
const getCookies = (cookieString) => cookieString
    .split('; ')
    .reduce((prev, current) => {
    const [name, ...value] = current.split('=');
    prev[name] = value.join('=');
    return prev;
}, {});
export function getCookieConsent(cookieString) {
    const consentCookie = getCookies(cookieString).CookieConsent;
    if (consentCookie) {
        const parsedCookieConsent = JSON.parse(consentCookie
            .replace(/%2c/gi, ',')
            .replace(/%27|'/g, '"')
            .replace(/([{\\[,])\s*([a-zA-Z0-9_]+?):/g, '$1"$2":'));
        return parsedCookieConsent;
    }
}
